import styled from 'styled-components';

export const IconWrapper = styled.div`
	width: 100px;
	height: 100px;
`;
